module.exports = __webpack_public_path__ + "img/brook_rd_b3.b221fc33.jpg";